<div class="generate_pdf" id="pdfG">
    <div class="card_header">
        <a [routerLink]="['/']">
            <img src="./assets/images/capitaland-cla-logo.png" alt="">
        </a>
        <a [routerLink]="['/']">
            <img src="./assets/images/logo-cla.png" alt="">
        </a>
    </div>
    <p class="_location"> {{this.displayParkName}}</p>
    <div class="_content">
        <h3>{{this.vegname}}</h3>
        <p>({{this.species}})</p>
        <div class="_qr">
            <!-- <img src="./assets/images/qr_code.png" alt=""> -->
            
            <img [src]="imageofQrCode" alt="qrcode" class="mb-3 mb-md-4">
        </div>
        <small>Scan this QR Code to view details about the plant</small>
    </div>
</div>